import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { ProfileCreateInput } from '../generated/globalTypes';
import { createProfileMutation, createProfileMutationVariables } from '../generated/createProfileMutation';
import { profileFieldsFragment } from '../models/Profile';

/**
 * Get a callback to create a Profile in the store.
 */
export function useCreateProfileCallback(): [(model: ProfileCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createProfileMutation, createProfileMutationVariables>(
        gql`
            mutation createProfileMutation ($model: ProfileCreateInput!) {
                createProfile(model: $model) {
                    ...profileFields
                }
            }

            ${profileFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: ProfileCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
